module.exports = __webpack_public_path__ + "img/Flag_of_Laos.ba5dea76.svg";